import {React, useRef, useEffect, useState} from 'react'
import tickMark from '../../../src/assets/images/icons/tickMark2.0.svg';
import doNotDisturb from '../../../src/assets/images/icons/doNotDisturb.svg';
import circleInfoSolid from '../../../src/assets/images/icons/circle-info-solid.svg';
import triangleExclamationSolid from '../../../src/assets/images/icons/triangle-exclamation-solid.svg';
import  "./ToastifyIconComponent.scss"

function ToastifyIconComponent() {
    const [parentClasses, setParentClasses] = useState("");

    const iconRef = useRef(null);
    useEffect(() => {
        const parent = iconRef.current.parentNode?.parentNode?.parentNode;
        setParentClasses(parent.className);
    }, []);
  return (
      <div className={"icon"} ref={iconRef}>
          {parentClasses.includes('success') && (<img src={tickMark} className={'success-icon'} alt="Tick mark icon" />)}
          {parentClasses.includes('error') && (<img src={doNotDisturb}  className={'error-icon'} alt="Do not disturb icon" />)}
          {parentClasses.includes('warning') && (<img src={circleInfoSolid}  className={'warning-icon'} alt="Circle info solid" />)}
          {parentClasses.includes('info') && (<img src={triangleExclamationSolid}  className={'info-icon'} alt="Triangle exclamation solid" />)}
      </div>
  )
}

export default ToastifyIconComponent